<div class="full-flex-height justify-content-center align-items-center flex-row innerAppButton appButtons">
   <a
      *ngIf="canAccessProducts"
      href="./products/standard"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-blue"><i class="fa fa-search"></i></h1>
            <h4 class="text-center">By Vetcor Product</h4>
         </div>
      </div>
   </a>
   <a
      href="./products/hospital"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-blue"><i class="fas fa-building"></i></h1>
            <h4 class="text-center">By Hospital</h4>
         </div>
      </div>
   </a>
   <a
      *ngIf="canAccessProducts"
      href="./products/admin"
      class="box mr-5">
      <div class="card">
         <div class="card-body">
            <h1 class="card-title ico text-center appButton-blue"><i class="fa fa-user-cog"></i></h1>
            <h4 class="text-center">Admin</h4>
         </div>
      </div>
   </a>
</div>
<vc-products-feedback />
